import { Loading } from 'element-ui';
import { MessageBox } from "element-ui";
import { Dialog } from "vant";
import { getPlatform } from "@tencentcloud/universal-api";

let loadingInstance = null;  // 用来存储 loading 实例

export function startLoading(options = {}) {
  if (loadingInstance) return;

  const defaultOptions = {
    text: '加载中...',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)',
    lock: true,
  };

  const config = { ...defaultOptions, ...options };

  loadingInstance = Loading.service({
    text: config.text,
    spinner: config.spinner,
    background: config.background,
    lock: config.lock,
  });
}

export function stopLoading() {
  if (loadingInstance) {
    loadingInstance.close();
    loadingInstance = null;
  }
}

export function showUpgradeDialog(h, showClose, content, confirmButtonText, callback, callbackCancel, otherOptions = {}) {
  const isPC = getPlatform() === "pc"; // 判断是否为PC端
  const messageContent = h("div", [
    h(
      "div",
      {
        style:
          "margin-top:5px;display:flex;align-items:center;justify-content:space-between;",
      },
      [
        h("div", {
          style: "display:flex;align-items:center;font-size: 16px;font-weight: 600;"
        }, [
          otherOptions.titleIcon || h("i", {
            class: "el-icon-warning-outline",
            style: "margin-right:3px;color: #14A0E6;font-size: 20px;",
          }),
          otherOptions.title || "提示",
        ]),
        isPC && otherOptions?.showRightClose && h("i", {
          style: "font-size: 18px;color: #333333;",
          class: "el-icon-close",
          on: {
            click(){
              MessageBox.close()
            }
          }
        }, '')
      ]
    ),
    otherOptions?.headerBottomBorder || h(
      "div",
      {
        style:
          "background: #EFEFEF;height:1px;margin: 17px 0 24px 0;",
      },
      ""
    ),
    h(
      "div",
      {
        style:
          "font-size: 14px;line-height: 22px;color: #333333;font-weight: 400;margin-bottom: 14px;",
      },
      content
    ),
    otherOptions?.footerLeftExtra || "",
  ]);

  if (isPC) {
    MessageBox({
      confirmButtonText,
      confirmButtonClass: "upgrade-dialog-pc-btn",
      showClose: false,
      showCancelButton: showClose,
      customClass: "upgrade-dialog-pc",
      cancelButtonClass: 'upgrade-dialog-pc-cancel',
      closeOnPressEscape: false,
      closeOnClickModal: false,
      message: messageContent,
      ...(otherOptions||{}),
      ...(otherOptions.message ? {} : {
        title: undefined
      }),
      // 高于 van-popup 抽屉等浮层（默认 2000+），确保确认框在最顶层
      zIndex: otherOptions.zIndex != null ? otherOptions.zIndex : 100000,
    }).then(callback).catch(() => {
      if (callbackCancel) callbackCancel(); // 如果取消按钮被点击，执行 callbackCancel
    });
  } else {
    Dialog.alert({
      title: "温馨提示",
      message: content,
      confirmButtonText,
      confirmButtonColor: "#14A0E6",
      showCancelButton: showClose,
      showClose: showClose,
      className: "upgrade-dialog-h5",
    }).then(callback).catch(() => {
      if (callbackCancel) callbackCancel(); // 如果取消按钮被点击，执行 callbackCancel
    });
  }
}

/** * 显示签名对话框
 * @param {Object} options - 对话框配置
 * @param {Function} options.success - 确认按钮点击后的回调函数
 * showMsgDialog({
        method: 'confirm',
        title: '',
        message: '您尚未设置手写签名，请完善签名后再进行线上诊疗',
        showCancelButton: true,
        confirmButtonText: '前往设置',
        cancelButtonText: '稍后设置',
        className: 'signature-dialog-h5 signature-dialog-h5-confirm',
      })
 */
export function showMsgDialog(options = {
  h: () => {},
  method: 'alert',
  success: function() {},
}) {
  const isPC = !options.isShowH5 && getPlatform() === "pc"; // 判断是否为PC端
  if(isPC) { 
    const { h, message, confirmButtonText, showClose, success, callbackCancel, ...otherOptions } = options;
    showUpgradeDialog(options.h, options.showClose, options.message, options.confirmButtonText, options.success, options.callbackCancel, otherOptions || {})
  } else {
    Dialog[options.method]({
      title: options.title || "温馨提示",
      message: options.message || `未识别到您的姓名，请重新手写您的姓名，手写工整、字迹清晰`,
      confirmButtonText: options.confirmButtonText || '我知道了',
      confirmButtonColor: options.confirmButtonColor || "#14A0E6",
      showClose: options.showClose || false,
      className: options.className || "signature-dialog-h5",
      ...options,
      ...(options.title ? {} : {
        title: undefined
      }),
    }).then(options.success).catch(() => {
      if (options.callbackCancel) options.callbackCancel(); // 如果取消按钮被点击，执行 callbackCancel
    });
  }
  
}

// 缓存 getAppointAndNotReceiveNum 接口的响应数据
let cachedAppointData = null;

// 缓存 getNotReceiveByDocPage 各维度（按原始请求体区分）的列表长度
const cachedNotReceiveLenMap = {};

// 生成 getNotReceiveByDocPage 的缓存键（区分不同的 serviceType/internetVisit/regStatus）
export function getNotReceiveCacheKey(config) {
  try {
    const raw = config?._rawData || {};
    const serviceType = raw?.serviceType || '';
    const internetVisit = raw?.internetVisit || '';
    const regStatus = raw?.regStatus || '';
    return `${serviceType}|${internetVisit}|${regStatus}`;
  } catch (e) {
    return 'default';
  }
}

// 检测 getAppointAndNotReceiveNum 接口数值变化
export function checkAppointDataChange(newData, logTraceId) {
  if (!cachedAppointData) {
    cachedAppointData = newData;
    return false;
  }
  
  // 动态获取所有数值字段
  const numericFields = Object.keys(newData).filter(key => 
    typeof +newData[key] === 'number'
  );
  
  let hasChange = false;
  const changes = {};
  
  Array.isArray(numericFields) && numericFields.forEach(field => {
    const oldValue = cachedAppointData[field] || 0;
    const newValue = newData[field] || 0;
    if (oldValue !== newValue) {
      hasChange = true;
      changes[field] = {
        old: oldValue,
        new: newValue
      };
    }
  });
  
  if (hasChange) {
    const totalCounts = {};
    Array.isArray(numericFields) && numericFields.forEach(field => {
      totalCounts[field] = {
        old: cachedAppointData[field] || 0,
        new: newData[field] || 0
      };
    });
    
    const changesWithTotal = {
      ...changes,
      totalCounts
    };
    
    // 更新缓存数据
    cachedAppointData = newData;
    
    return {
      changes: changesWithTotal,
      logTraceId
    };
  }
  
  return false;
}

// 检测 getNotReceiveByDocPage 接口列表长度变化
export function checkNotReceiveDataChange(response, responseData, logTraceId) {
  const key = getNotReceiveCacheKey(response?.config);
  const oldLen = cachedNotReceiveLenMap[key] || 0;
  const newLen = (responseData && Array.isArray(responseData?.rows)) ? responseData?.rows?.length : 0 || 
                 (responseData && Array.isArray(responseData?.list)) ? responseData?.list?.length : 0 ;
  if (oldLen !== newLen) {
    cachedNotReceiveLenMap[key] = newLen;
    const rawData = response?.config?._rawData || {};
    return {
      changes: {
        listLength: {
          old: oldLen,
          new: newLen
        }
      },
      serviceType: rawData?.serviceType || '',
      logTraceId
    };
  }
  
  return false;
}

// 按groupId分组核心方法
export function groupByGroupId(dataList) {
  if (!Array.isArray(dataList) || dataList.length === 0) {
    return [];
  }

  const groupMap = new Map();
  dataList.forEach(item => {
    const { groupId, regId, onlineStatusDesc, onlineStatus } = item;
    if (!groupId) return; // 跳过无groupId的数据

    if (!groupMap.has(groupId)) {
      // 初始化目标格式分组
      groupMap.set(groupId, {
        groupId: groupId,
        regIdList: [],
        onlineStatusDesc: onlineStatusDesc || '',
        onlineStatus: onlineStatus || ''
      });
    }

    const group = groupMap.get(groupId);
    // 避免regId重复
    if (!group.regIdList.includes(regId)) {
      group.regIdList.push(regId);
    }
  });

  return Array.from(groupMap.values());
}

// 浏览器信息检测工具函数
export function getBrowserInfo() {
  const userAgent = navigator.userAgent.toLowerCase();
  let browser = 'Unknown';
  let version = 'Unknown';
  
  // 检测常见浏览器
  if (userAgent.includes('edge')) {
    browser = 'Edge';
    version = (userAgent.match(/edge\/([\d.]+)/) || [])[1] || version;
  } else if (userAgent.includes('chrome')) {
    browser = 'Chrome';
    version = (userAgent.match(/chrome\/([\d.]+)/) || [])[1] || version;
  } else if (userAgent.includes('firefox')) {
    browser = 'Firefox';
    version = (userAgent.match(/firefox\/([\d.]+)/) || [])[1] || version;
  } else if (userAgent.includes('safari')) {
    browser = 'Safari';
    version = (userAgent.match(/safari\/([\d.]+)/) || [])[1] || version;
  } else if (userAgent.includes('trident') || userAgent.includes('msie')) {
    browser = 'IE';
    version = (userAgent.match(/(msie |rv:)([\d.]+)/) || [])[2] || version;
  }
  
  return { browser, version };
}